/**
 * B2B auth store — текущий member + workspace + token.
 * Хранится отдельно от C2C `useAuthStore` (разные таблицы, разные JWT, разные ключи в localStorage).
 * Один человек может быть залогинен и в C2C (jobskills.work), и в B2B (jobskills.work/b2b/*) одновременно.
 */
import { create } from 'zustand';
import {
  setB2BAuthSession,
  clearB2BAuthSession,
  getB2BAuthToken,
  getStoredB2BMember,
  getStoredB2BWorkspace,
  isB2BAuthenticated as checkPersistedAuth,
} from '../utils/b2bAuth';

export const useB2BAuthStore = create((set) => ({
  // Hydrated from localStorage on store creation.
  member: getStoredB2BMember(),
  workspace: getStoredB2BWorkspace(),
  token: getB2BAuthToken(),
  isAuthenticated: checkPersistedAuth(),

  /**
   * Save full auth payload (from /api/b2b/auth/{login,register}).
   */
  login: ({ token, member, workspace }) => {
    setB2BAuthSession({ token, member, workspace });
    set({ token, member, workspace, isAuthenticated: true });
  },

  logout: () => {
    clearB2BAuthSession();
    set({ token: null, member: null, workspace: null, isAuthenticated: false });
  },

  updateMember: (updates) => {
    set((state) => {
      const next = state.member ? { ...state.member, ...updates } : null;
      if (next) setB2BAuthSession({ token: state.token, member: next, workspace: state.workspace });
      return { member: next };
    });
  },

  updateWorkspace: (updates) => {
    set((state) => {
      const next = state.workspace ? { ...state.workspace, ...updates } : null;
      if (next) setB2BAuthSession({ token: state.token, member: state.member, workspace: next });
      return { workspace: next };
    });
  },

  refresh: () => {
    const ok = checkPersistedAuth();
    if (!ok) {
      clearB2BAuthSession();
      set({ token: null, member: null, workspace: null, isAuthenticated: false });
    }
    return ok;
  },
}));

export const selectB2BMember = (s) => s.member;
export const selectB2BWorkspace = (s) => s.workspace;
export const selectB2BIsAuthenticated = (s) => s.isAuthenticated;
